/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">Add Catetory</h4>
        <div>
            <form class="border border-light p-5">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label>Category</label>
                        <input type="text" ref="title" id="" class="form-control mb-4" placeholder="Category">
                    </div>
                </div>
                <button class="btn btn-info btn-block my-4" @click.prevent="addCategory()">Add Category</button>
            </form>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
export default {
    name: 'AddCategory',
    components: {

    },
    data() {
        return {
            fastAdminToken : localStorage.getItem("fastAdminToken")
        }
    },
    methods: {
        addCategory() {
            let data = {
                title: this.$refs.title.value,
            }
            const config = {
                headers: {
                    Authorization: "Bearer " + this.fastAdminToken,
                    'Content-Type': 'application/json'
                }
            }
            this.$toast.open({
                message: "Processing : Creating Category Please Wait...",
                type: 'info'
            })
            axios.post(this.$apiURI + "/category/create", data, config)

                .then((response) => {
                    if (response.data.error) {
                        this.$toast.open({
                            message: "Error : " + response.data.message,
                            type: 'error'
                        });
                    } else {
                        this.$refs.title.value = "";
                        this.$toast.open({
                            message: "Category Created Successfully",
                            type: 'success'
                        })
                    }

                }).catch((error) => {
                    this.$toast.open({
                        message: "Error : " + error.response.data.message,
                        type: 'error'
                    });
                })
        }
    }
}
</script>
